import styled from "styled-components";

export const MatterPageWrapper = styled.div`
  padding: 32px 24px;
  background: #fff;
  // height: 100vh;
  font-family: 'Manrope', sans-serif;
  overflow-y: scroll;
  height: 100%;
`;
export const MatterPageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: #959ab1;
`;
export const MaterPageTitle = styled.div`
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 24px;
  leading-trim: Cap height;
  line-height: 28px;
  letter-spacing: 0%;
  color: #1b2028;
`;
export const MatterPageContentWrapper = styled.div`
  display: flex;
  gap: 18px;
  padding-bottom: 24px;
  align-items: baseline;
`;

export const HorizondalLine = styled.hr`
  border: 1px solid #dde2e9;
`;
export const PaginationContainer = styled.div`
  margin-top: 1.75rem;
`;

export const MyMattersToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 6px 12px;
  border: 1px solid ${props => (props.$active ? '#0C53BB' : '#DDE2E9')};
  border-radius: 6px;
  background: ${props => (props.$active ? '#F1F6FE' : '#FFFFFF')};
  color: ${props => (props.$active ? '#0C53BB' : '#48566B')};
  font-family: 'Manrope', sans-serif;
  font-weight: ${props => (props.$active ? 600 : 500)};
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: ${props => (props.$active ? '#E3EEFC' : '#F5F6F9')};
    border-color: ${props => (props.$active ? '#0A47A3' : '#CCD2DD')};
  }

  &:focus-visible {
    outline: 2px solid #0C53BB;
    outline-offset: 2px;
  }
`;
